import { ProposalFieldTraversalSource } from "work/proposals/negotiation/proposal-field-history-request-context";
import type ProposalField from "work/proposals/proposal-fields/proposal-field";

/**
 * Whether arriving at a field should surface the Comments/Changes pane.
 *
 * **A "Prev / Next Change" press never does.** What a stop is about is answered where the stop is: an
 * unread change opens that field's own history popover, and an issue scrolls its highlighted row into
 * view — the redline selections already do that off `activeReviewField`. The proposal's one
 * conversation is neither of those things. The pane is seated in the page's row rather than over it,
 * so opening it takes width from the very content the reader was sent to read, and the first thing
 * they have to do on arriving is close it.
 *
 * A field reporting its own traverse-in — a focus, an Edit press — still surfaces it. That is the
 * reader arriving at the field by their own hand rather than being sent there, and the pane is not
 * competing with anything the traverser is trying to show them.
 *
 * The one exception on that side is a fee-schedule *category* (#5118), where the row that answers the
 * stop sits in the widest table on the page and the pane takes its width from that table. The id-less
 * whole-schedule field is not an exception: a stop there means there are no categories at all, so
 * there is no row to reach and no table to narrow.
 */
export function proposalTraversalSurfacesCommentsPane(args: {
  source: ProposalFieldTraversalSource;
  field: ProposalField;
}): boolean {
  if (args.source === ProposalFieldTraversalSource.Traverser) return false;
  return !args.field.isFeeScheduleCategory;
}
